import { useEffect } from 'react';
import { showPercent, showRoundAmount } from '../../libs/util';
import { groupInteger } from '../../libs/numberFormat';

const Component = ({
  product,
  currency,
  expiredAmount,
  daysLeft,
  productAPR,
  referenceRate,
  setOnTotalFixingDaysCalculated,
}) => {
  // Propagate the computed "Total Fixing Days" back to the parent so the order
  // payload's calculationPeriod / tenor are populated instead of left null.
  useEffect(() => {
    if (typeof setOnTotalFixingDaysCalculated === 'function') {
      setOnTotalFixingDaysCalculated(daysLeft != null ? daysLeft : null);
    }
  }, [daysLeft, setOnTotalFixingDaysCalculated]);

  const getCurrency = (currency) => {
    if (!currency) {
      return currency;
    }
    return currency.toUpperCase();
  };

  return (
    <>
      <div className="p-2">
        <div className="nk-ivp-summary card-text">
          <div className="row">
            <div className="col-12">
              <span className="lead-text">
                <span>Total Fixing Days</span>
                <br />
                <span className="text-dark extra-dark">
                  {product && daysLeft ? daysLeft : '-'}
                </span>
              </span>
              <span className="sub-text">Days</span>
            </div>
          </div>
          <div className="card-title text-center pt-2 mt-2 border-top">
            <span className="title form-label">
              Daily Indicative Investment Amount
            </span>
          </div>
          <div className="row">
            {currency && getCurrency(currency) === 'USD' ? (
              <>
                <div className="col-6 border-right">
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      Reference rate
                    </span>
                  </span>
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {referenceRate ? showPercent(referenceRate, 2) : '-'}
                    </span>
                  </span>
                </div>
                <div className="col-6">
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {expiredAmount && referenceRate
                        ? showRoundAmount(
                            expiredAmount * referenceRate,
                            currency
                          )
                        : 0}
                    </span>
                  </span>
                  <span className="lead-text">
                    <span className=" text-dark extra-small">
                      {currency ? getCurrency(currency) : '-'}
                    </span>
                  </span>
                </div>
              </>
            ) : (
              <div className="col-12">
                <span className="lead-text">
                  <span className=" text-dark extra-small">
                    {groupInteger(expiredAmount)}
                  </span>
                </span>
                <span className="lead-text">
                  <span className=" text-dark extra-small">
                    {currency ? getCurrency(currency) : '-'}
                  </span>
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Component;
